import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";
import axios from "axios";
import store from "./../store";

export default class Cognito {
  configure(config, authType) {
    if (config.userPool) {
      this.userPool = config.userPool;
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId,
      });
    }
    // Config.region = config.region;
    /*
    Config.credentials = new CognitoIdentityCredentials({
    IdentityPoolId: config.IdentityPoolId
    })
    */
    this.options = config;
    this.isUseCognito = authType === "Cognito";
  }

  static install = (Vue, options, authType) => {
    Object.defineProperty(Vue.prototype, "$cognito", {
      get() {
        return this.$root._cognito;
      },
    });

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito;
          this._cognito.configure(options, authType);
        }
      },
    });
  };

  /**
   * username, passwordでログイン
   */
  login(username, password) {
    const userData = { Username: username, Pool: this.userPool };
    const cognitoUser = new CognitoUser(userData);
    const authenticationData = { Username: username, Password: password };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          // 実際にはクレデンシャルなどをここで取得する(今回は省略)
          return resolve(result);
        },
        onFailure: (err) => {
          return reject(err);
        },
      });
    });
  }

  /**
   * ログアウト
   */
  logout() {
    this.userPool.getCurrentUser().signOut();
  }

  /**
   * ログインしているかの判定
   */
  isAuthenticated() {
    if (this.isUseCognito) {
      const cognitoUser = this.userPool.getCurrentUser();
      return new Promise((resolve, reject) => {
        if (cognitoUser === null) {
          return reject({ message: "" });
        }
        cognitoUser.getSession((err, session) => {
          if (err) {
            return reject(err);
          } else {
            if (!session.isValid()) {
              return reject(session);
            } else {
              return resolve(session);
            }
          }
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        if (store.state.auth.isLogIn) {
          var nowUnixTime = Date.now();
          var idTokenJson = parseJwt(store.state.auth.idToken);
          //[1] アクセストークンの有効期限の確認
          var accessToken = parseJwt(store.state.auth.accessToken);
          var accessTokenExp = accessToken.exp * 1000;
          if (accessTokenExp - 60 * 1000 > nowUnixTime) {
            var auth = {
              isLogIn: true,
              realms: store.state.auth.realms,
              accessToken: store.state.auth.accessToken,
              idToken: store.state.auth.idToken,
              refreshToken: store.state.auth.refreshToken,
              subject: idTokenJson.sub,
              privilege: Number(idTokenJson.privilege || 0),
            };
            store.commit("auth", auth);
            sessionStorage.setItem("auth", JSON.stringify(auth));
            return resolve(store.state.auth);
          } else {
            //[2] リフレッシュトークンの有効期限の確認
            var refreshToken = parseJwt(store.state.auth.refreshToken);
            var refreshTokenExp = refreshToken.exp * 1000;
            if (refreshTokenExp > nowUnixTime) {
              //[3] トークンの再取得
              axios
                .post("/api/access_token/", {
                  refreshToken: store.state.auth.refreshToken,
                  hospitalCode: store.state.auth.realms,
                })
                .then((response) => {
                  var auth = {
                    isLogIn: true,
                    realms: store.state.auth.realms,
                    accessToken: response.data.data.accessToken,
                    idToken: store.state.auth.idToken,
                    refreshToken: store.state.auth.refreshToken,
                    subject: idTokenJson.sub,
                    privilege: Number(idTokenJson.privilege || 0),
                  };
                  store.commit("auth", auth);
                  sessionStorage.setItem("auth", JSON.stringify(auth));
                  return resolve(store.state.auth);
                })
                .catch(() => {
                  return reject({
                    message: "ログイン有効期限の更新に失敗しました",
                  });
                });
            } else {
              store.commit("auth", {
                isLogIn: false,
                realms: store.state.auth.realms,
              });
              if (sessionStorage.getItem("auth")) {
                sessionStorage.removeItem("auth");
              }
              return resolve();
            }
          }
        } else {
          if (sessionStorage.getItem("auth")) {
            sessionStorage.removeItem("auth");
          }
          return reject();
        }
      });
    }
  }
}

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}
